import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class PtReservationService {
  private api = inject(ApiService);

  // --- flags ---
  getGlobalFlag(): Promise<any> {
    return this.api.get('/reservation/flag/mypage');
  }

  // --- menu ---
  getMenuAll(): Promise<any> {
    return this.api.get('/reservation/menu/');
  }

  // --- schedule ---
  getAvailability(studioId: number | string, slot: string, count: number, isPt: number | string): Promise<any> {
    return this.api.get(`/reservation/schedule/studio/${studioId}/slot/${slot}/reserve_count/${count}/type/${isPt}`);
  }

  // --- records ---
  get(id: number | string): Promise<any> {
    return this.api.get(`/reservation/record/${id}`);
  }

  getAll(): Promise<any> {
    return this.api.get('/reservation/record/member');
  }

  async create(json: any): Promise<any> {
    try {
      const res = await firstValueFrom(this.api.postRaw<any>('/reservation/record/new', json));
      if (res?.status !== undefined && res.status !== 200) {
        this.api.getRouter().navigate(['/error']); return null;
      }
      return res;
    } catch (err: any) {
      if (err?.status !== 401) this.api.getRouter().navigate(['/error']);
      throw err;
    }
  }

  async remove(json: any): Promise<any> {
    try {
      const res = await firstValueFrom(this.api.postRaw<any>('/reservation/record/remove', json));
      return res;
    } catch (err: any) {
      if (err?.status !== 401) this.api.getRouter().navigate(['/error']);
      throw err;
    }
  }
}
